import * as ACTION_TYPES from '../types';
import API from '../services/api';

export const login = (user) => dispatch => {
    return new Promise((resolve, reject) => {
        dispatch({ type: ACTION_TYPES.LOGIN_REQUEST });
        API.postData(`users/login`, user).then(res => {
            dispatch({ type: ACTION_TYPES.LOGIN_SUCCESS });
            resolve(res.data);
        }).catch(err => {
            dispatch({ type: ACTION_TYPES.LOGIN_FAIL });
            reject(err);
        })
    });
}
export const verifyCode = (user) => dispatch => {
    return new Promise((resolve, reject) => {
        dispatch({ type: ACTION_TYPES.REGISTER_REQUEST });
        API.postData(`users/verify`, user).then(res => {
            dispatch({ type: ACTION_TYPES.REGISTER_SUCCESS });
            resolve(res.data);
        }).catch(err => {
            dispatch({ type: ACTION_TYPES.REGISTER_FAIL });
            reject(err);
        })
    });
}
export const register = (user) => dispatch => {
    return new Promise((resolve, reject) => {
        dispatch({ type: ACTION_TYPES.REGISTER_REQUEST });
        API.postData(`users/register`, user).then(res => {
            dispatch({ type: ACTION_TYPES.REGISTER_SUCCESS });
            resolve(res.data);
        }).catch(err => {
            dispatch({ type: ACTION_TYPES.REGISTER_FAIL });
            reject(err);
        })
    });
}
